import { IMessageTypeEditItem, MessageTypeEditItem } from "./messageTypeEditItem";

export interface IMessageTypeEdit {
    item: IMessageTypeEditItem;
}

export class MessageTypeEdit implements IMessageTypeEdit {
    item: IMessageTypeEditItem;

    constructor();
    constructor(obj: IMessageTypeEdit);
    constructor(obj?: any) {
        this.item = new MessageTypeEditItem(obj ? obj.item : null);
    }
}